import type { Event } from "@spwn/types/firebase/firestore";

export const getEventTimeForBeforeArchiveComparison = (
  event: Event
): number => {
  // // 特定のイベントでは、終了判定にされないように、最後のpartのopenTimeをイベント時間として扱う
  // // SFLのための暫定対応
  // const useLastPartOpenTimeEventIds = new Set([
  //   // グランドファイナル
  //   // "evt_251213-SFL2025POGF",
  //   // テスト用イベント (Test Streaming 3)
  //   "evt_zhOP3ynj5u2X1BPb5zz1",
  // ]);
  // const useLastPartOpenTime = event._id
  //   ? useLastPartOpenTimeEventIds.has(event._id)
  //   : false;
  // // FIXME: parts内でopenTimeが最も遅いものを見るようにする
  // const lastPart = event.parts[event.parts.length - 1];
  // if (useLastPartOpenTime && lastPart?.openTime) {
  //   return Number(lastPart.openTime.seconds);
  // }

  return Number(event.datetime.seconds);
};
